import React, { useState, useContext, useEffect } from 'react';

const StoreContext = React.createContext();

export const useStore = () => useContext( StoreContext );



function StoreProvider({ children }) {
    
    // const [ user, setUser ] = useState({});
    const [ ride, setRide ] = useState([]); 
    const [ filters, setFilters ] = useState({ state:"", city: "" });
    const [ status, setStatus ] = useState(""); // upcoming, past


    // Fetching Date
    useEffect(() => {

        (async function() {
            await fetch('https://assessment.api.vweb.app/rides')
            // https://assessment.api.vweb.app/rides
            .then( response => response.json() )
            .then(res => {
                   setRide( res );

            });


        })()


    }, [  setRide ]);


    function selectUpcomingRides() {
        const date = new Date();
        const now = date.getTime();
      
        
        return ride.filter( obj => {
            const filterState = filters.state ? obj.state === filters.state : !filters.state;
            const filterCity  = filters.city  ? obj.city === filters.city : !filters.city;
            const dt = new Date(obj.date);
            const temp = dt.getTime();
            // console.log(temp)
            return (temp  >= now) && filterState && filterCity
            
        });
    }

    function selectPastRides() {
        const date = new Date();
        const now = date.getTime();
        
        return ride.filter( obj => {
            const filterState = filters.state ? obj.state === filters.state : !filters.state;
            const filterCity  = filters.city  ? obj.city === filters.city : !filters.city;
            const dt = new Date(obj.date);
            const temp = dt.getTime();
            return (temp  < now) && filterState && filterCity
        });
    }


    function selectAllRides() {
        return ride.filter( obj => {
            const filterState = filters.state ? obj.state === filters.state : !filters.state;
            const filterCity  = filters.city  ? obj.city === filters.city : !filters.city;
    
            return filterState && filterCity
        });
    }


    const getRides = () => {

        switch(status) {
            case "upcoming": 
            return selectUpcomingRides();

            case "past": 
            return selectPastRides();

            default: 
            return selectAllRides();
        }
    }

    const handleStatus = ( state ) => {
        setStatus( state );
    }



    const handleFilters = ( obj ) => {
        setFilters( obj );
    } 


    const value = {
        handleStatus,
        handleFilters,
        selectUpcomingRides,
        selectPastRides,
        getRides,
        filters,
        status,
        ride
    };


    return (
        <StoreContext.Provider value = { value } >
            { children }
        </StoreContext.Provider>
    )
}

export default StoreProvider;